import { render } from "./SectionDropdown.vue?vue&type=template&id=3046315a&scoped=true"
import script from "./SectionDropdown.vue?vue&type=script&lang=js"
export * from "./SectionDropdown.vue?vue&type=script&lang=js"

import "./SectionDropdown.vue?vue&type=style&index=0&id=3046315a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3046315a"]])

export default __exports__